import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sound-on",
  "use": "sound-on-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"sound-on\"><path fill-rule=\"evenodd\" d=\"M10.862.646a.832.832 0 0 1 1.305.688v13.333a.834.834 0 0 1-1.305.688L5.519 11.69H1.333a.833.833 0 0 1-.833-.834V5.143c0-.46.373-.833.833-.833H5.52zm4.037 4.332A.834.834 0 0 0 13.6 6.023c.863 1.072.863 2.883 0 3.955a.834.834 0 0 0 1.3 1.045c1.362-1.695 1.362-4.35 0-6.045\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol